import dayjs from 'dayjs'
import React from 'react'
import AopsBox from '../../../../components/apos/AopsBox'
import SectionHeader from '../../../../components/apos/SectionHeader'
import InfoCard from '../ui/InfoCard'

const MyInfoSection = ({ personalInfo, employmentInfo }) => {
  const formatDateOrDash = (value) => {
    if (!value) return '-'
    const d = dayjs(value)
    if (!d.isValid()) return '-'
    return d.format('YYYY년 MM월 DD일')
  }

  const personalData = [
    { label: '이름', value: personalInfo?.name },
    {
      label: '생년 월일',
      value: formatDateOrDash(personalInfo?.birthDate),
    },
    { label: '연락처', value: personalInfo?.phone },
    { label: '이메일', value: personalInfo?.email },
    { label: '집주소', value: personalInfo?.address },
  ]

  const employmentData = [
    { label: '재직 상태', value: employmentInfo?.status },
    { label: '소속 팀', value: employmentInfo?.team },
    { label: '직무', value: employmentInfo?.position },
    { label: '근무 형태', value: employmentInfo?.employmentType },
    {
      label: '입사일',
      value: formatDateOrDash(employmentInfo?.joinDate),
    },
    {
      label: '퇴사일',
      value: formatDateOrDash(employmentInfo?.leaveDate),
    },
  ]

  return (
    <div>
      <SectionHeader
        title="내 인사 관리"
        subtitle="내 인사정보를 조회할 수 있고 사내 문서를 관리할 수 있어요"
      />
      <AopsBox
        style={{ padding: '24px 24px 44px 24px' }}
        title="내 인사 정보"
        borderBottom={true}
      >
        <InfoCard
          title="개인 기본 정보"
          data={personalData}
          gridColumns="repeat(2, 1fr)"
        />
        <div style={{ height: '16px' }} />
        <InfoCard
          title="재직 정보"
          data={employmentData}
          gridColumns="repeat(3, 1fr)"
        />
      </AopsBox>
    </div>
  )
}

export default MyInfoSection
